import { useState } from 'react';

import { DEFAULT_PAGE_SIZE } from '@treneo/shared/utils';

import { DataGridPaginationMode } from '../data-grid-wrapper';

const DEFAULT_PAGE = 0;

export type UseServerPaginationOptions = {
  initialPage?: number;
  initialPageSize?: number;
};

export type ServerPaginationGridProps = {
  paginationMode: typeof DataGridPaginationMode.Server;
  page: number;
  pageSize: number;
  rowCount: number;
  onPaginationChange: (page: number, pageSize: number) => void;
};

export const useServerPagination = (
  options?: UseServerPaginationOptions
): {
  page: number;
  pageSize: number;
  setPage: (page: number) => void;
  onPaginationChange: (page: number, pageSize: number) => void;
  gridPaginationProps: (rowCount: number) => ServerPaginationGridProps;
} => {
  const [page, setPage] = useState(options?.initialPage ?? DEFAULT_PAGE);
  const [pageSize, setPageSize] = useState(options?.initialPageSize ?? DEFAULT_PAGE_SIZE);

  const onPaginationChange = (newPage: number, newPageSize: number) => {
    setPage(newPage);
    setPageSize(newPageSize);
  };

  const gridPaginationProps = (rowCount: number): ServerPaginationGridProps => ({
    paginationMode: DataGridPaginationMode.Server,
    page,
    pageSize,
    rowCount,
    onPaginationChange
  });

  return {
    page,
    pageSize,
    setPage,
    onPaginationChange,
    gridPaginationProps
  };
};
